import { render, staticRenderFns } from "./update-plan-type.component.vue?vue&type=template&id=08e56a64&"
import script from "./update-plan-type.component.vue?vue&type=script&lang=ts&"
export * from "./update-plan-type.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports